import React from "react";
import FieldWrapper from "../Common/FieldWrapper";
import purifyHTML from "../../../utils/purifyHTML";

export default class CheckboxGroup extends FieldWrapper {
  handleChange = (e, value) => {
    const {
      formikForm,
      formikField,
      config: { name },
    } = this.props;

    const groupValue = formikField.value.split(",") || [];
    const index = groupValue.indexOf(value);
    if (index !== -1) groupValue.splice(index, 1);
    else groupValue.push(value);

    formikForm.setFieldValue(name, groupValue.join(","));
    formikField.onBlur(e); //validate directly for errors
  };

  renderField() {
    const {
      formikField,
      isRequired,
      config: { label, name, options, direction, readOnly, disabled },
    } = this.props;

    const listeners = {};
    if (readOnly) {
      listeners.onClick = (e) => {
        e.preventDefault();
      };
    }

    return (
      <div
        role="group"
        aria-label={label}
        aria-required={!!isRequired}
        className={`field__group ${
          direction === "horizontal" ? "field__group--horizontal" : ""
        } ${direction === "two-columns" ? "field__group--two-columns" : ""}`}
      >
        {!formikField.value && <input type="hidden" name={name} value="" />}
        {options.map(({ label, value }) => (
          <div
            key={`${name}_${value}`}
            className="field__option field__option--checkbox"
          >
            <input
              className="field__checkbox"
              type="checkbox"
              id={`${name}_${value}`}
              value={value}
              checked={
                formikField.value && formikField.value.indexOf(value) !== -1
              }
              disabled={!!disabled}
              aria-label={label}
              {...formikField}
              onChange={(e) => this.handleChange(e, value)}
              {...listeners}
            />
            <label
              htmlFor={`${name}_${value}`}
              className="field__option-label"
              dangerouslySetInnerHTML={purifyHTML(label)}
              {...listeners}
            />
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Field/CheckboxGroup.js